import { IconButton, SvgIcon, styled } from "@mui/material";

const StyledIconButton = styled(IconButton)({
  borderRadius: "6px",
  width: "40px",
  height: "40px",
  padding: "5px",
  marginLeft: 0,
  "&.MuiButtonBase-root": {    
    "& .MuiSvgIcon-root": {
      width: "30px",
      height: "30px",
    },
  },
  "&:hover": {
    backgroundColor: "rgba(255, 255, 255, 0.10);",
  },
  "&.active": {
    //backgroundColor: "#3BD6FF4D",
    backgroundColor: "rgba(57, 210, 252, 0.20)",
    "&:hover": {
      backgroundColor: "rgba(255, 255, 255, 0.10);",
    },
  }
});

interface MenuButtonProps {
  icon: any; 
  viewBox?: string;
  padding?: string;
  path?: string;
  children?: React.ReactNode;
  active?: boolean;
}

const MenuButton: React.FC<MenuButtonProps> = ({
  icon, 
  viewBox = "0 0 30 30",  
  path,
  padding,
  children,
  active,
}): React.ReactElement => {
  const handleOnClick = (path: string) => {
    window.open(
      process.env.REACT_APP_PUBLIC_URL + path,
      "_self"
    );
  };

  return (
    <StyledIconButton
      edge="start"
      color="inherit"
      disableRipple
      className={active ? "active" : undefined}
      onClick={() => path ? handleOnClick(path) : {}}
    >
      <SvgIcon
        component={icon}
        viewBox={viewBox}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: padding,
        }}        
      />
      {children}
    </StyledIconButton>
  )
};

export default MenuButton;